import {
  BiometricDatapointRecord,
  useGetBiometricDatapointsQuery,
} from 'services/biometricsService';

interface UseBloodGlucoseDatapointsOptions {
  /** yyyy-MM-dd */
  startDate?: string;
  /** yyyy-MM-dd */
  endDate?: string;
}

// Fetches blood glucose datapoints for a program user; skipped until programUserId is known.
export const useBloodGlucoseDatapoints = (
  programUserId?: number,
  options: UseBloodGlucoseDatapointsOptions = {},
) => {
  const { data, isLoading, isError, refetch } = useGetBiometricDatapointsQuery(
    {
      programUserId: programUserId ?? 0,
      biometricType: 'blood_glucose',
      startDate: options.startDate,
      endDate: options.endDate,
    },
    { skip: programUserId == null },
  );

  return {
    datapoints: (data ?? []) as BiometricDatapointRecord[],
    isLoading,
    isError,
    refetch,
  };
};
